// 水平等级测试结果
const grade = {
  namespaced: true,
  state: {
    isGrading: false,
    inGradingPage: false, // 当前在等级测试页面
    recommendLevel: 0,
    finaleLevel: 0,
    abilityAssess: {},
  },
  mutations: {
    SET_GRADE(state, payload) {
      state.isGrading = true
      state.recommendLevel = payload.aiDirectoryId
      state.finaleLevel = payload.level
      state.abilityAssess = payload.abilityAssess
    },
    CLEAR_GRADE(state) {
      state.isGrading = false
      state.recommendLevel = 0
      state.finaleLevel = 0
      state.abilityAssess = {}
    },
    PAGELOCATION(state, data) {
      state.inGradingPage = data
    },
  },
  actions: {
    refreshGrade({ commit }) {
      return new Promise((resolve, reject) => {
        window.utilV2.getData(
          window.ApiPath.get_spc_usermessage,
          {},
          (data) => {
            if (data.grading) {
              commit('SET_GRADE', data)
            } else {
              commit('CLEAR_GRADE')
            }
            resolve()
          },
          () => {
            reject()
          },
          { showLoading: false }
        )
      })
    },
    clearGrade({ commit }) {
      commit('CLEAR_GRADE')
    },
    inGradingPage({ commit }, data) {
      commit('PAGELOCATION', data)
    },
  },
}

export default grade
